module.exports = __webpack_public_path__ + "static/img/shilla-ipark.63e7fe7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/shilla-ipark.jpg
// module id = PXmy
// module chunks = 0